import { chunkSize, chunkReaderForBuffer } from '../../../app-core/lib/upload/chunk'
import type { Buff } from '../../../app-core/lib/upload/buffer'
import type { FileId } from '../../../shared/domain/files/types.no-deps'
import { writeChunk } from './fileChunk'

export async function writeArrayBufferToDisk(fileId: FileId, buffer: Buff) {
    const totalChunks = Math.ceil(buffer.byteLength / chunkSize)
    const chunkReader = chunkReaderForBuffer(buffer)
    for (let i = 0; i < totalChunks; i++) {
        const chunk = await chunkReader(i)
        await writeChunk(fileId, i, chunk)
    }
}
